import useDocumentTitle from "@/components/ui/common/document-title";
import DonationReportTable from "./table";

export default function DonationReport() {
  useDocumentTitle("Donation Report");

  return (
    <div className="w-full p-5 space-y-6">
      <div className="space-y-6">
        <DonationReportTable />
      </div>
    </div>
  );
}
